import { withDependencies } from '@wix/thunderbolt-ioc'
import { IPropsStore, Props } from '@wix/thunderbolt-symbols'
import type { ComponentWillMount, ViewerComponent } from 'feature-components'
import { SiteMembersApiSymbol } from '../symbols'
import type { ISiteMembersApi } from '../types'

export const SocialAuthWillMount = withDependencies(
	[SiteMembersApiSymbol, Props],
	(siteMembers: ISiteMembersApi, propsStore: IPropsStore): ComponentWillMount<ViewerComponent> => {
		return {
			componentTypes: ['SocialAuth'],
			componentWillMount(comp) {
				const socialAuthProps = siteMembers.getSocialAuthComponentProps()
				propsStore.update({ [comp.id]: socialAuthProps })
			},
		}
	}
)
